(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/top-app-bar/dist/mdc.topAppBar.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/top-app-bar/dist/mdc.topAppBar.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/top-app-bar/dist/mdc.topAppBar.js")) : factory(root["react"], root["classnames"], root["@material/top-app-bar/dist/mdc.topAppBar.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_113__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 107);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      107:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var FixedAdjust_1 = __webpack_require__(108);

        exports.TopAppBarFixedAdjust = FixedAdjust_1.default;

        var Section_1 = __webpack_require__(109);

        exports.TopAppBarSection = Section_1.default;

        var Row_1 = __webpack_require__(110);

        exports.TopAppBarRow = Row_1.default;

        var Title_1 = __webpack_require__(111);

        exports.TopAppBarTitle = Title_1.default;

        var Icon_1 = __webpack_require__(112);

        exports.TopAppBarIcon = Icon_1.default;

        var constants_1 = __webpack_require__(4);

        var mdc_topAppBar_1 = __webpack_require__(113);

        var TopAppBar =
        /** @class */
        function (_super) {
          __extends(TopAppBar, _super);

          function TopAppBar() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.topAppBarElement = React.createRef();
            _this.state = {
              classList: new Set(),
              style: {}
            };

            _this.initializeFoundation = function () {
              var _a = _this.props,
                  short = _a.short,
                  shortCollapsed = _a.shortCollapsed,
                  fixed = _a.fixed;

              if (_this.foundation) {
                _this.foundation.destroy();
              }

              if (short || shortCollapsed) {
                _this.foundation = new mdc_topAppBar_1.MDCShortTopAppBarFoundation(_this.adapter);
              } else if (fixed) {
                _this.foundation = new mdc_topAppBar_1.MDCFixedTopAppBarFoundation(_this.adapter);
              } else {
                _this.foundation = new mdc_topAppBar_1.MDCTopAppBarFoundation(_this.adapter);
              }

              _this.foundation.init();
            };

            _this.getMergedStyles = function () {
              var style = _this.state.style;
              return Object.assign({}, style, _this.props.style);
            };

            return _this;
          }

          Object.defineProperty(TopAppBar.prototype, "classes", {
            get: function get() {
              var _a;

              var classList = this.state.classList;
              var _b = this.props,
                  className = _b.className,
                  dense = _b.dense,
                  fixed = _b.fixed,
                  prominent = _b.prominent,
                  short = _b.short,
                  shortCollapsed = _b.shortCollapsed;
              return classnames_1.default(constants_1.cssClasses.BASE, Array.from(classList), className, (_a = {}, _a[constants_1.cssClasses.FIXED] = fixed, _a[constants_1.cssClasses.SHORT] = shortCollapsed || short, _a[constants_1.cssClasses.SHORT_COLLAPSED] = shortCollapsed, _a[constants_1.cssClasses.PROMINENT] = prominent, _a[constants_1.cssClasses.DENSE] = dense, _a));
            },
            enumerable: true,
            configurable: true
          });

          TopAppBar.prototype.componentDidMount = function () {
            this.initializeFoundation();

            if (this.props.scrollTarget) {
              this.setState({
                scrollTarget: this.props.scrollTarget
              });
            }
          };

          TopAppBar.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          };

          TopAppBar.prototype.componentDidUpdate = function (prevProps, prevState) {
            var _this = this;

            var foundationChanged = ['short', 'shortCollapsed', 'fixed'].some(function (variant) {
              return _this.props[variant] !== prevProps[variant];
            });

            if (foundationChanged) {
              // foundation.destroy() does not remove old variant className(s)
              this.setState({
                classList: new Set()
              }, this.initializeFoundation);
            }

            if (prevProps.scrollTarget !== this.props.scrollTarget) {
              this.foundation.destroyScrollHandler();
              this.setState({
                scrollTarget: this.props.scrollTarget
              });
            }

            if (prevState.scrollTarget !== this.state.scrollTarget) {
              this.foundation.initScrollHandler();
            }
          };
          /**
           * @deprecated since 0.11.0. Will be deleted in 0.13.0
           */


          TopAppBar.prototype.addClassesToElement
          /* istanbul ignore next */
          = function (classes, element) {
            var updatedProps = {
              className: classnames_1.default(classes, element.props.className)
            };
            return React.cloneElement(element, updatedProps);
          };

          Object.defineProperty(TopAppBar.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                addClass: function addClass(className) {
                  return _this.setState({
                    classList: _this.state.classList.add(className)
                  });
                },
                removeClass: function removeClass(className) {
                  var classList = _this.state.classList;
                  classList.delete(className);

                  _this.setState({
                    classList: classList
                  });
                },
                hasClass: function hasClass(className) {
                  return _this.classes.split(' ').includes(className);
                },
                setStyle: function setStyle(varName, value) {
                  var updatedStyle = Object.assign({}, _this.state.style);
                  updatedStyle[varName] = value;

                  _this.setState({
                    style: updatedStyle
                  });
                },
                getTopAppBarHeight: function getTopAppBarHeight() {
                  if (_this.topAppBarElement && _this.topAppBarElement.current) {
                    return _this.topAppBarElement.current.clientHeight;
                  }

                  return 0;
                },
                registerScrollHandler: function registerScrollHandler(handler) {
                  if (_this.state.scrollTarget && _this.state.scrollTarget.current) {
                    _this.state.scrollTarget.current.addEventListener('scroll', handler);
                  } else {
                    window.addEventListener('scroll', handler);
                  }
                },
                deregisterScrollHandler: function deregisterScrollHandler(handler) {
                  if (_this.state.scrollTarget && _this.state.scrollTarget.current) {
                    _this.state.scrollTarget.current.removeEventListener('scroll', handler);
                  } else {
                    window.removeEventListener('scroll', handler);
                  }
                },
                getViewportScrollY: function getViewportScrollY() {
                  return _this.state.scrollTarget && _this.state.scrollTarget.current ? _this.state.scrollTarget.current.offsetTop : window.pageYOffset;
                },
                getTotalActionItems: function getTotalActionItems() {
                  if (_this.topAppBarElement && _this.topAppBarElement.current) {
                    var actionItems = _this.topAppBarElement.current.querySelectorAll("." + constants_1.cssClasses.ACTION_ITEM);

                    return actionItems.length;
                  }

                  return 0;
                }
              };
            },
            enumerable: true,
            configurable: true
          });

          TopAppBar.prototype.render = function () {
            var _a = this.props,

            /* eslint-disable no-unused-vars */
            children = _a.children,
                className = _a.className,
                dense = _a.dense,
                fixed = _a.fixed,
                short = _a.short,
                shortCollapsed = _a.shortCollapsed,
                prominent = _a.prominent,
                scrollTarget = _a.scrollTarget,
                Tag = _a.tag,
                actionItems = _a.actionItems,
                navigationIcon = _a.navigationIcon,
                title = _a.title,
                otherProps = __rest(_a, ["children", "className", "dense", "fixed", "short", "shortCollapsed", "prominent", "scrollTarget", "tag", "actionItems", "navigationIcon", "title"])
            /* eslint-enable no-unused-vars */
            ;
            /**
             * @deprecated since 0.11.0. Will be deleted in 0.13.0
             */

            /* istanbul ignore if */


            if (actionItems || navigationIcon || title) {
              // TODO(mgr34): remove all deprecated statements and istanbul ignore's for v0.13.0
              var warning = 'actionItems, navigationIcon, and title  are deprecated  ' + 'since v0.11.0 and will be removed in v0.13.0. Please refer to ' + 'https://github.com/material-components/material-components-web-react' + '/blob/master/packages/top-app-bar/README.md';
              console.warn(warning);
              return (// @ts-ignore Tag does not have any construct https://github.com/Microsoft/TypeScript/issues/28892
                React.createElement(Tag, __assign({}, otherProps, {
                  className: this.classes,
                  style: this.getMergedStyles(),
                  ref: this.topAppBarElement
                }), React.createElement("div", {
                  className: 'mdc-top-app-bar__row'
                }, this.renderTitleAndNavigationSection(), this.renderActionItems()))
              );
            }

            return (// @ts-ignore Tag does not have any construct https://github.com/Microsoft/TypeScript/issues/28892
              React.createElement(Tag, __assign({}, otherProps, {
                className: this.classes,
                style: this.getMergedStyles(),
                ref: this.topAppBarElement
              }), children)
            );
          };
          /**
           * @deprecated since 0.11.0. Will be deleted in 0.13.0
           */


          TopAppBar.prototype.renderTitleAndNavigationSection
          /* istanbul ignore next */
          = function () {
            var title = this.props.title;
            var classes = 'mdc-top-app-bar__section mdc-top-app-bar__section--align-start';
            return React.createElement("section", {
              className: classes
            }, this.renderNavigationIcon(), React.createElement("span", {
              className: 'mdc-top-app-bar__title'
            }, title));
          };
          /**
           * @deprecated since 0.11.0. Will be deleted in 0.13.0
           */


          TopAppBar.prototype.renderNavigationIcon
          /* istanbul ignore next */
          = function () {
            var navigationIcon = this.props.navigationIcon;

            if (!navigationIcon) {
              return;
            }

            return this.addClassesToElement('mdc-top-app-bar__navigation-icon', navigationIcon);
          };
          /**
           * @deprecated since 0.11.0. Will be deleted in 0.13.0
           */


          TopAppBar.prototype.renderActionItems
          /* istanbul ignore next */
          = function () {
            var _this = this;

            var actionItems = this.props.actionItems;

            if (!actionItems) {
              return;
            }

            return React.createElement("section", {
              className: 'mdc-top-app-bar__section mdc-top-app-bar__section--align-end',
              role: 'toolbar'
            }, actionItems.map(function (item, key) {
              var elementWithClasses = _this.addClassesToElement('mdc-top-app-bar__action-item', item);

              return React.cloneElement(elementWithClasses, {
                key: key
              });
            }));
          };

          TopAppBar.defaultProps = {
            className: '',
            dense: false,
            fixed: false,
            prominent: false,
            short: false,
            shortCollapsed: false,
            style: {},
            tag: 'header'
          };
          return TopAppBar;
        }(React.Component);

        exports.default = TopAppBar;
        /***/
      },

      /***/
      108:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        ;

        var FixedAdjust = function FixedAdjust(_a) {
          var
          /* eslint-disable react/prop-types */
          _b = _a.tag,

          /* eslint-disable react/prop-types */
          Tag = _b === void 0 ? 'main' : _b,
              children = _a.children,
              _c = _a.className,
              className = _c === void 0 ? '' : _c,
              _d = _a.dense,
              dense = _d === void 0 ? false : _d,
              _e = _a.prominent,
              prominent = _e === void 0 ? false : _e,
              _f = _a.short,
              short = _f === void 0 ? false : _f,

          /* eslint-enable react/prop-types */
          otherProps = __rest(_a, ["tag", "children", "className", "dense", "prominent", "short"]);

          var _g;

          var base = 'mdc-top-app-bar';
          var suffix = '-fixed-adjust';
          var classes = classnames_1.default(className, (_g = {}, _g[base + '--short' + suffix] = short, _g[base + '--dense' + suffix] = dense && !prominent, _g[base + '--dense-prominent' + suffix] = dense && prominent, _g[base + '--prominent' + suffix] = !dense && prominent, _g[base + '-' + suffix] = !short && !dense && !prominent, _g));
          return (// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/26635
            // @ts-ignore
            React.createElement(Tag, __assign({
              className: classes
            }, otherProps), children)
          );
        };

        exports.default = FixedAdjust;
        /***/
      },

      /***/
      109:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2019 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var constants_1 = __webpack_require__(4);

        ;

        var Section = function Section(_a) {
          var
          /* eslint-disable react/prop-types */
          align = _a.align,
              className = _a.className,
              children = _a.children,
              _b = _a.tag,
              Tag = _b === void 0 ? 'section' : _b,
              otherProps = __rest(_a, ["align", "className", "children", "tag"])
          /* eslint-enable react/prop-types */
          ;

          var _c;

          return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
            React.createElement(Tag, __assign({
              className: classnames_1.default(className, constants_1.cssClasses.SECTION, (_c = {}, _c[constants_1.cssClasses.SECTION_START] = align === 'start', _c[constants_1.cssClasses.SECTION_END] = align === 'end', _c))
            }, otherProps), children)
          );
        };

        exports.default = Section;
        /***/
      },

      /***/
      110:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2019 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var constants_1 = __webpack_require__(4);

        ;

        var Row = function Row(_a) {
          var
          /* eslint-disable react/prop-types */
          children = _a.children,
              className = _a.className,
              _b = _a.tag,
              Tag = _b === void 0 ? 'div' : _b,
              otherProps = __rest(_a, ["children", "className", "tag"])
          /* eslint-enable react/prop-types */
          ;

          return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
            React.createElement(Tag, __assign({
              className: classnames_1.default(className, constants_1.cssClasses.ROW)
            }, otherProps), children)
          );
        };

        exports.default = Row;
        /***/
      },

      /***/
      111:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2019 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var constants_1 = __webpack_require__(4);

        ;

        var Title = function Title(_a) {
          var
          /* eslint-disable react/prop-types */
          children = _a.children,
              className = _a.className,
              _b = _a.tag,
              Tag = _b === void 0 ? 'span' : _b,
              otherProps = __rest(_a, ["children", "className", "tag"])
          /* eslint-enable react/prop-types */
          ;

          return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
            React.createElement(Tag, __assign({
              className: classnames_1.default(className, constants_1.cssClasses.TITLE)
            }, otherProps), children)
          );
        };

        exports.default = Title;
        /***/
      },

      /***/
      112:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2019 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var constants_1 = __webpack_require__(4);

        var Icon = function Icon(_a) {
          var
          /* eslint-disable react/prop-types */
          _b = _a.actionItem,

          /* eslint-disable react/prop-types */
          actionItem = _b === void 0 ? false : _b,
              _c = _a.navIcon,
              navIcon = _c === void 0 ? false : _c,
              className = _a.className,
              children = _a.children,
              otherProps = __rest(_a, ["actionItem", "navIcon", "className", "children"])
          /* eslint-enable react/prop-types */
          ;

          var _d;

          return React.cloneElement(children, __assign({}, otherProps, {
            className: classnames_1.default(className, children.props.className, (_d = {}, _d[constants_1.cssClasses.ACTION_ITEM] = actionItem, _d[constants_1.cssClasses.NAV_ICON] = navIcon, _d))
          }));
        };

        exports.default = Icon;
        /***/
      },

      /***/
      113:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_113__;
        /***/
      },

      /***/
      4:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2019 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN

        var BASE = 'mdc-top-app-bar';
        var SECTION = BASE + "__section";
        var cssClasses = {
          BASE: BASE,
          ROW: BASE + "__row",
          SECTION: SECTION,
          SECTION_START: SECTION + "--align-start",
          SECTION_END: SECTION + "--align-end",
          FIXED: BASE + "--fixed",
          SHORT: BASE + "--short",
          SHORT_COLLAPSED: BASE + "--short-collapsed",
          PROMINENT: BASE + "--prominent",
          DENSE: BASE + "--dense",
          TITLE: BASE + "__title",
          ACTION_ITEM: BASE + "__action-item",
          NAV_ICON: BASE + "__navigation-icon"
        };
        exports.cssClasses = cssClasses;
        /***/
      }
      /******/

    })
  );
});